import StudentProgressReport from "ProgressReport/routes/ProgressReportDetails/routes/StudentProgressReport";

export default store => ({
  path: "progress-report",
  childRoutes: [StudentProgressReport(store)],
});
